import { isNumber } from './isNumber';

export const constrain = (num, min, max) => {
	if (isNumber(min) && num <= min) return min;
	if (isNumber(max) && num >= max) return max;
	return num;
};
